// One Timeline child path per transportation alternatives dialog: the day route can't hold four
// `alternatives/:experienceId` siblings the way each Transportations tab does.
export const CAR_RENTAL_ALTERNATIVES_PATH = 'car-rental-alternatives';
export const FLIGHT_ALTERNATIVES_PATH = 'flight-alternatives';
export const TRANSFER_ALTERNATIVES_PATH = 'transfer-alternatives';
export const TRANSPORTATION_ALTERNATIVES_PATH = 'transportation-alternatives';
